import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { AdminUser, AuthResponse } from '../../models/auth.interface';
import { ApiConfigService } from './api-config.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private get apiUrl(): string { return `${this.apiConfig.apiUrl}/auth`; }
  private currentUserSubject = new BehaviorSubject<AdminUser | null>(null);
  public currentUser$ = this.currentUserSubject.asObservable();

  constructor(private http: HttpClient, private apiConfig: ApiConfigService) {
    const savedUser = localStorage.getItem('shell_muze_admin');
    if (savedUser) {
      try {
        this.currentUserSubject.next(JSON.parse(savedUser));
      } catch (e) {
        localStorage.removeItem('shell_muze_admin');
      }
    }
  }

  public get currentUserValue(): AdminUser | null {
    return this.currentUserSubject.value;
  }

  public get token(): string | null {
    return this.currentUserValue?.token || localStorage.getItem('shell_muze_token');
  }

  login(credentials: { email: string; password: string }): Observable<AuthResponse> {
    return this.http.post<AuthResponse>(`${this.apiUrl}/login`, credentials).pipe(
      tap((res) => {
        if (res && res.token) {
          localStorage.setItem('shell_muze_admin', JSON.stringify(res));
          localStorage.setItem('shell_muze_token', res.token);
          this.currentUserSubject.next(res);
        }
      })
    );
  }

  loginWithGoogle(credential: string): Observable<AuthResponse> {
    return this.http.post<AuthResponse>(`${this.apiUrl}/admin/google`, { credential }).pipe(
      tap((res) => {
        if (res && res.token) {
          localStorage.setItem('shell_muze_admin', JSON.stringify(res));
          localStorage.setItem('shell_muze_token', res.token);
          this.currentUserSubject.next(res);
        }
      })
    );
  }

  logout(): void {
    localStorage.removeItem('shell_muze_admin');
    localStorage.removeItem('shell_muze_token');
    this.currentUserSubject.next(null);
  }

  isLoggedIn(): boolean {
    return !!this.token;
  }
}
